<template>
    <div>
        <div class="d-flex flex-column-fluid">
            <!--begin::Container-->
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-lg-12 col-xl-12">
                                <div class="card card-custom gutter-b bg-transparent shadow-none border-0">
                                    <div class="card-header align-items-center  border-bottom-dark px-0">
                                        <div class="card-title mb-0">
                                            <h3 class="card-label mb-0 font-weight-bold text-body">
                                                Список возвратов
                                            </h3>
                                        </div>
                                        <div class="icons d-flex">
                                            <router-link to="/admin/add-order-return" class="btn ml-2 p-0 kt_notes_panel_toggle" data-toggle="tooltip" title="" data-placement="right" data-original-title="Check out more demos" v-if="$parent.permissions.includes('purchase-manage')">
                                                <span class="bg-secondary h-30px font-size-h5 w-30px d-flex align-items-center justify-content-center  rounded-circle shadow-sm " v-on:click="
                                                            display_form = !display_form
                                                        ">
                                                    <svg width="25px" height="25px" viewBox="0 0 16 16" class="bi bi-plus white" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                        <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"></path>
                                                    </svg>
                                                </span>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 ">
                                <div class="card card-custom gutter-b bg-white border-0">
                                    <div class="card-body">
                                        <div>
                                            <div class=" table-responsive" id="printableTable">

                                                <div id="order_wrapper" class="dataTables_wrapper no-footer">

                                                    <div class="dataTables_length" id="order_length"><label>Show
                                                            <select name="order_length" aria-controls="order" class=""
                                                                v-model="limit" v-on:change="fetchOrderReturn()">
                                                                <option value="10">10</option>
                                                                <option value="25">25</option>
                                                                <option value="50">50</option>
                                                                <option value="100">100</option>
                                                                <option value="200">200</option>
                                                                <option value="500">500</option>
                                                                <option value="1000">1000</option>
                                                            </select> entries</label></div>

                                                    <div id="order_filter" class="dataTables_filter">
                                                        <label>Search:<input type="search" class="" placeholder=""
                                                                aria-controls="order" v-model="searchParameter"
                                                                @keyup="fetchOrderReturn()"></label></div>
                                                    <table id="order" class="display dataTable no-footer" order="grid">
                                                        <thead class="text-body">
                                                            <tr sale="row">
                                                                <th class="sorting" tabindex="0" rowspan="1" colspan="1"
                                                                    aria-label="sale: activate to sort column ascending"
                                                                    style="width: 95.5288px">
                                                                    ID
                                                                </th>
                                                                <th class="sorting" tabindex="0" rowspan="1" colspan="1"
                                                                    aria-label="sale: activate to sort column ascending">
                                                                    Клиент
                                                                </th>
                                                                <th class="sorting" tabindex="0" rowspan="1" colspan="1"
                                                                    aria-label="sale: activate to sort column ascending"
                                                                    style="width: 95.5288px">
                                                                    Сумма
                                                                </th>

                                                                <th class="sorting" tabindex="0" rowspan="1" colspan="1"
                                                                    aria-label="sale: activate to sort column ascending"
                                                                    style="width: 95.5288px">
                                                                    Дата
                                                                </th>
                                                                <!--<th class="sorting" tabindex="0" rowspan="1" colspan="1"
                                                                    aria-label="sale: activate to sort column ascending"
                                                                    style="width: 95.5288px">
                                                                    Способ оплаты
                                                                </th>
                                                                <th class="sorting" tabindex="0" rowspan="1" colspan="1"
                                                                    aria-label="sale: activate to sort column ascending"
                                                                    style="width: 95.5288px">
                                                                    Метод доставки
                                                                </th>-->
                                                                <th class="sorting" tabindex="0" rowspan="1" colspan="1"
                                                                    aria-label="sale: activate to sort column ascending"
                                                                    style="width: 95.5288px">
                                                                    Статус
                                                                </th>
                                                                <th style="width: 20px">
                                                                    Действие
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody class="kt-table-tbody text-dark">
                                                            <tr class="kt-table-row kt-table-row-level-0 odd"
                                                                order="row" v-for="order in orderReturn"
                                                                v-bind:key="order.id">
                                                                <td>
                                                                    {{ order.order_return_id }}
                                                                </td>
                                                                <td>
                                                                    {{ order.billing_first_name}}
                                                                    {{ order.billing_last_name}}
                                                                </td>
                                                                <td>
                                                                    {{ order.order_price}} €
                                                                </td>
                                                                <td>
                                                                    {{ order.order_date_formatted }}
                                                                </td>
                                                                <!--<td>

                                                                </td>
                                                                <td>

                                                                </td>-->
                                                                <td>
                                                                    {{ (order.processed)? 'Проведен' : 'Заготовка' }}
                                                                </td>
                                                                <td>
                                                                    <router-link
                                                                        :to="'/admin/order-return/' + order.order_return_id+ '/edit'"
                                                                        class="click-edit" id="click-edit1"
                                                                        data-toggle="tooltip" title=""
                                                                        data-placement="right"><i
                                                                            class="fa fa-edit"></i></router-link>
                                                                        <a v-if="!order.processed" class="" href="#"
                                                                            @click="deleteOrderReturn(order.order_return_id)"><i
                                                                            class="fa fa-trash"></i>
                                                                        </a>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <ul class="pagination pagination-sm m-0 float-right">
                                                        <li v-bind:class="[{disabled: !pagination.prev_page_url}]"><a
                                                                class="page-link" href="#"
                                                                @click="fetchOrderReturn(pagination.prev_page_url)">Previous</a>
                                                        </li>

                                                        <li class="disabled"><a class="page-link text-dark"
                                                                href="#">Page {{ pagination.current_page }} of
                                                                {{ pagination.last_page }}</a></li>

                                                        <li v-bind:class="[{disabled: !pagination.next_page_url}]"
                                                            class="page-item"><a class="page-link" href="#"
                                                                @click="fetchOrderReturn(pagination.next_page_url)">Next</a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import ErrorHandling from "./../../ErrorHandling";
    export default {
        data() {
            return {
                display_form: 0,
                orderReturn: [],
                searchParameter: '',
                sortBy: 'id',
                sortType: 'DESC',
                limit: 10,
                error_message: '',
                edit: false,
                actions: false,
                pagination: {},
                request_method: "",
                is_default: "0",
                token: [],
                currency: [],
                errors: new ErrorHandling(),
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute("content")
            };
        },

        methods: {
            fetchCurrency() {
                this.$parent.loading = true;
                var token = localStorage.getItem('token');
                const config = {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                };
                var responseData = {};

                axios.get('/api/admin/currency?is_default=1', config)
                    .then(res => {
                        if (res.data.status == "Success") {
                            this.currency = res.data.data;
                        }
                    })
                    .finally(() => (this.$parent.loading = false));
            },
            fetchOrderReturn(page_url) {
                this.$parent.loading = true;
                let vm = this;
                page_url = page_url || "/api/admin/order-return";
                var arr = page_url.split('?');

                if (arr.length > 1) {
                    page_url += '&limit=' + this.limit;
                } else {
                    page_url += '?limit=' + this.limit;
                }
                if (this.searchParameter != null) {
                    page_url += '&searchParameter=' + this.searchParameter;
                }
                page_url += '&sortBy=' + this.sortBy + '&sortType=DESC';
                page_url += '&getCreatedBy=1';

                var responseData = {};

                axios.get(page_url, this.token).then(res => {
                        this.orderReturn = res.data.data;
                        vm.makePagination(res.data.meta, res.data.links);
                    })
                    .finally(() => (this.$parent.loading = false));
            },

            deleteOrderReturn(id) {
            if (confirm("Are You Sure?")) {
                this.$parent.loading = true;
                axios
                .delete(`/api/admin/order-return/${id}`, this.token)
                .then((res) => {
                    if (res.data.status == "Success") {
                    this.$toaster.success(res.data.message);
                    this.fetchOrderReturn();
                    }
                })
                .catch((err) => console.log(err))
                .finally(() => (this.$parent.loading = false));
            }
            },

            makePagination(meta, links) {
                let pagination = {
                    current_page: meta.current_page,
                    last_page: meta.last_page,
                    next_page_url: links.next,
                    prev_page_url: links.prev
                };

                this.pagination = pagination;
            },
            sorting(sortBy) {
                this.sortBy = sortBy;
                this.sortType = this.sortType == 'asc' || this.sortType == 'ASC' ? this.sortType = 'desc' : this
                    .sortType = 'asc';
                this.fetchOrderReturn();
            },
            getCurrencyTitle() {
                return this.currency == null ? '' : '(' + this.currency.title + ')';
            }
        },
        mounted() {

            var token = localStorage.getItem('token');
            this.token = {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            };
            this.fetchCurrency();
            this.fetchOrderReturn();
        },
        props: ['loading'],
    };

</script>
